export default "__VITE_PUBLIC_ASSET__a9a08de4__"